import React from 'react';
import { Box } from '@mui/material';
import PageHeader from '../../PageHeader/PageHeader';
import { palette, spaces } from '../../../assets/styles/themes/tokens';
import MainGridArea from '../MainGridArea';

interface CollectionsAppLayoutProps {
  title: string;
  subtext?: string;
  body: React.ReactNode;
  context: React.ReactNode;
  backgroundClick?: () => void;
  tabs?: React.ReactNode;
  headerButton?: React.ReactNode;
}

const CollectionsAppLayout: React.FC<CollectionsAppLayoutProps> = (props) => {
  return <Box>
    <Box sx={{ 
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: spaces.md,
      height: '64px',  // Lets keep height consistent regardless of headerButton
    }}>
      <PageHeader
        text={props.title}
        subtext={props.subtext}
        sx={{
          color: palette.text.primary,
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          gap: spaces.xs,
          paddingY: 0,
        }}
      />
      { props.headerButton }
    </Box>
    { props.tabs }
    <MainGridArea
      body={props.body}
      context={props.context}
      backgroundClick={props.backgroundClick}
    />
  </Box>;
};

export default CollectionsAppLayout;
